module.exports = __webpack_public_path__ + "img/global_loading.5ca65fd5.gif";